import { useMutation } from '@tanstack/react-query';

import { MembershipTypeFormSchemaValues } from 'src/features/membershipType/formSchema';
import { MembershipType } from 'src/features/membershipType/types';
import axios from 'src/lib/axios';
import { MutationConfig } from 'src/lib/react-query';
import { GeneralSmartParkError } from 'src/registry/types/axios';
import { formatResourcePath } from 'src/utils/regex';

const RESOURCE = `sp-core/:parkingId/memberships/membership-type/:typeId/copy/`;

type MutationFnType = typeof mutationFn;

interface DTO extends MembershipTypeFormSchemaValues {
    parkingId: string;
    typeId: string;
}

const mutationFn = ({ parkingId, typeId, ...data }: DTO): Promise<MembershipType> => {
    return axios.post(formatResourcePath(RESOURCE, { parkingId, typeId }), data);
};

const useMutationHook = (options: MutationConfig<MutationFnType, GeneralSmartParkError>) =>
    useMutation({
        mutationFn,
        ...options,
    });

export { useMutationHook as useCopyMembershipType };
